export enum RouteName {
	MAP = 'map',
}
